<template>
  <form
    id="questionForm"
    action
    method="POST"
  >
    <h1
      class="title is-3"
      v-t="'title'"
    />

    <b-field
      :label="$t('fields.labels.title')"
      :type="{ 'is-danger': errors.title }"
      :message="errors.title ? errors.title[0] : ''"
      :custom-class="errors.title ? 'has-text-danger' : ''"
    >
      <b-input
        type="text"
        :placeholder="$t('fields.placeholders.title')"
        :value="formData.title"
        v-model="formData.title"
        size="is-medium"
        required
      />
    </b-field>

    <b-field
      :label="$t('fields.labels.content')"
      :type="{ 'is-danger': errors.content }"
      :message="errors.content ? errors.content[0] : ''"
      :custom-class="errors.content ? 'has-text-danger' : ''"
    >
      <rich-editor
        :content.sync="formData.content"
        :placeholder="$t('fields.placeholders.content')"
        @change="contentChange"
      />
    </b-field>

    <button
      type="submit"
      class="button is-danger"
      @click.prevent="save()"
    >
      <b-icon icon="save" />
      <span v-t="'save'" />
    </button>
  </form>
</template>

<script>
import API from '@/api'
import RichEditor from '@/components/RichEditor'

export default {
  name: 'QuestionForm',

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  components: { RichEditor },

  data () {
    return {
      errors: {},
      formData: {
        product_id: this.product.id,
        title: '',
        content: ''
      }
    }
  },
  methods: {
    contentChange ({ content }) {
      this.formData.content = content
    },

    save () {
      API.questions.store(this.formData, this.saveCallback, this.errorCallback)
    },

    saveCallback (article) {
      this.$snotify.success(this.$t('alerts.success'), this.$t('alert.title.success'))
      this.$router.push({ name: 'manual' })
      window.scrollTo(0, 0)
    },

    errorCallback (err) {
      this.$snotify.error(this.$t('alerts.error'), this.$t('alert.title.error'))
      if (err.response) {
        this.errors = err.response.data.errors
      }
    }
  }
}
</script>

<i18n src="@/lang/locales.json"></i18n>
<i18n>
{
  "en-US": {
    "title": "Create new question",
    "fields": {
      "labels": {
        "title": "Question",
        "content": "Answer"
      },
      "placeholders": {
        "title": "Question",
        "content": "Answer"
      }
    },
    "save": "Save informations",
    "alerts": {
      "success": "Question created successfully!",
      "error": "An error occurred when creating the question!"
    }
  },
  "pt-BR": {
    "title": "Cadastrar nova pergunta",
    "fields": {
      "labels": {
        "title": "Pergunta",
        "content": "Resposta"
      },
      "placeholders": {
        "title": "Digite aqui a pergunta",
        "content": "Informe aqui a resposta da pergunta"
      }
    },
    "save": "Salvar informações",
    "alerts": {
      "success": "Pergunta cadastrada com sucesso!",
      "error": "Erro ao cadastrar a pergunta!"
    }
  }
}
</i18n>
